import StudentGreeting from './StudentGreeting';

export default StudentGreeting;
